import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineSkeletonItemDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

export const TIMELINE_SKELETON_TITLE_WIDTHS: Array<`${number}%`> = [
    "72%",
    "56%",
    "64%"
];

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "flex-start",
        flexDirection: "row"
    },
    content: {
        minWidth: 0,
        flex: 1
    }
});

export const useStyles = ({
    controlPaddings,
    lineHeight,
    markerSize,
    spaces,
    gap
}: TimelineSkeletonItemDynamicStyleType) => {
    const styles = {
        content: {
            paddingTop: (markerSize - lineHeight) / 2,
            gap: spaces.spacingXs
        } as Mutable<ViewStyle>,
        container: {
            gap: controlPaddings.small
        } as Mutable<ViewStyle>,
        item: {
            paddingBottom: gap
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
